import { Divider } from 'components/Divider/Divider';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TaxDiscrepancy } from 'services/invoiceDiscrepancies/types';
import { RelatedTransactionsContent } from './RelatedTransactionsContent';

type TaxDiscrepancyViewProps = Pick<TaxDiscrepancy, 'data' | 'relatedTransactions'>;

export const TaxDiscrepancyView: React.FC<TaxDiscrepancyViewProps> = ({ data, relatedTransactions }) => {
  const { actual, expected } = data;
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-4">
      <div className="grid w-full grid-cols-3 gap-y-5 text-xs text-gray-500">
        <div className="contents">
          <span></span>
          <span className="text-end">
            {t('invoiceVerification:detailsPage.discrepanciesModal.content.taxDiscrepancy.headers.expected')}
          </span>
          <span className="text-end">
            {t('invoiceVerification:detailsPage.discrepanciesModal.content.taxDiscrepancy.headers.actual')}
          </span>
        </div>
        <div className="contents">
          <span>
            {t('invoiceVerification:detailsPage.discrepanciesModal.content.taxDiscrepancy.rows.taxPercentage')}
          </span>
          <span className="text-end font-semibold text-gray-900">{expected?.percentage ?? 0}%</span>
          <span className="text-end font-semibold text-gray-900">{actual?.percentage ?? 0}%</span>
        </div>
      </div>
      <Divider />
      <RelatedTransactionsContent relatedTransactions={relatedTransactions} />
    </div>
  );
};
